<template>
  <div class="row middle center parent">
    <div class="relative child">
      <kinesis-element class="castle-back" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/bg_resize_castle_back.webp"
            type="image/webp"
          />
          <img
            alt="castle back towers"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_back.png"
            width="1116"
            height="588"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="mist" type="translate" :strength="30">
        <!--<kinesis-element type="translate" :strength="30">-->
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/bg_resize_castle_mist.webp"
            type="image/webp"
          />
          <img
            alt="white mist"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_mist.png"
            width="1116"
            height="325"
          />
        </picture>
        <!--</kinesis-element>-->
      </kinesis-element>
      <!--<kinesis-element  type="depth" :strength="5">-->
      <kinesis-element class="middle-roof" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/bg_resize_castle_middle_roof.webp"
            type="image/webp"
          />
          <img
            alt="small tower"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_middle_roof.png"
            width="1202"
            height="303"
          />
        </picture>
      </kinesis-element>
      <!--</kinesis-element>-->
      <kinesis-element class="castle-roof" type="translate" :strength="25">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="orange castle roof"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_roof.png"
            width="721"
            height="632"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="castle-front" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/bg_resize_castle_front.webp"
            type="image/webp"
          />
          <img
            alt="castle front wall entrance"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_front.png"
            width="1920"
            height="625"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="castle-tower" type="translate" :strength="25">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="castle tall tower"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_tower.png"
            width="1080"
            height="1572"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="glow" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="characters white glow"
            class="f-w-h"
            src="../assets/img/bg_resize_castle_glow.png"
            width="800"
            height="800"
          />
        </picture>
      </kinesis-element>
      <!-- <LeafAnimation class="leafs" /> -->
      <kinesis-element class="blu" type="translate" :strength="50">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/character_resize_blu.webp"
            type="image/webp"
          />
          <img
            alt="character blu"
            class="f-w-h"
            src="../assets/img/character_resize_blu.png"
            width="677"
            height="538"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="fuse" type="translate" :strength="50">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/character_resize_fuse.webp"
            type="image/webp"
          />
          <img
            alt="character fuse"
            class="f-w-h"
            src="../assets/img/character_resize_fuse.png"
            width="531"
            height="469"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="sheal" type="translate" :strength="60">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/character_resize_sheal.webp"
            type="image/webp"
          />
          <img
            alt="main character sheal"
            class="f-w-h"
            src="../assets/img/character_resize_sheal.png"
            width="1059"
            height="1331"
          />
        </picture>
      </kinesis-element>
      <div class="grand-lukto">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <source
            srcset="../assets/img/logo_resize_grand_lukto.webp"
            type="image/webp"
          />
          <img
            alt="game logo"
            class="f-w-h"
            src="../assets/img/logo_resize_grand_lukto.png"
            width="686"
            height="340"
          />
        </picture>
      </div>
      <kinesis-element class="shadow" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="characters shadow"
            class="f-w-h"
            src="../assets/img/character_resize_shadow.png"
            width="1676"
            height="327"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="leave-a" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="big green leaf"
            class="f-w-h"
            src="../assets/img/bg_resize_fg_grass_1.png"
            width="757"
            height="254"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="leave-c" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="small green leaf"
            class="f-w-h"
            src="../assets/img/bg_resize_fg_grass_3.png"
            width="522"
            height="552"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="leave-a-der" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="big green leaf"
            class="f-w-h"
            src="../assets/img/bg_resize_fg_grass_1_der.png"
            width="757"
            height="254"
          />
        </picture>
      </kinesis-element>
      <kinesis-element class="leave-c-der" type="translate" :strength="30">
        <picture>
          <source srcset="" media="(min-width: 600px)" />
          <img
            alt="small green leaf"
            class="f-w-h"
            src="../assets/img/bg_resize_fg_grass_3_der.png"
            width="522"
            height="552"
          />
        </picture>
      </kinesis-element>
    </div>
  </div>
</template>

<script>
//import LeafAnimation from "../components/LeafAnimation.vue";

export default {
  name: "HelloWorld",
  components: {
    // LeafAnimation,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.translate {
  transform: translate(-50%, -50%);
}

.leafs {
  position: absolute;
  top: -10vh;
  left: -5vw;
  width: 110vw;
  height: 120vh;
}

.parent {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  height: calc(100 * var(--vh, 1vh));
  z-index: 1;
}

.child {
  min-width: 180vh;
  width: 100%;
  height: 100vh;
  height: calc(100 * var(--vh, 1vh));
  display: flex;
  align-items: center;
  flex-direction: column;
}

.child2 {
  height: 300px;
  width: 300px;
  position: absolute;
  top: calc(50vh - 150px);
  left: calc(50vw - 150px);
}

.picture {
  height: 20rem;
  width: 300px;
}

.castle-front {
  position: absolute;
  min-width: 120vw;
  width: 273vh;
  bottom: -19vh;
  left: -21vh;
  overflow: hidden;
}

.castle-back {
  position: absolute;
  min-width: 110vw;
  width: 205vh;
  height: auto;
  left: -37vh;
  bottom: 6vw;
  overflow: hidden;
}

.middle-roof {
  position: absolute;
  width: 133vh;
  min-width: 70vw;
  height: auto;
  bottom: 31vh;
}

.castle-roof {
  position: absolute;
  bottom: 26vh;
  width: 40vh;
  min-width: 20vw;
  height: auto;
  right: -10vh;
}

.castle-tower {
  position: absolute;
  bottom: 25vh;
  right: -25vh;
  width: 52vh;
  min-width: 30vw;
  height: auto;
  resize: both;
}

.mist {
  position: absolute;
  width: 60vh;
  height: auto;
  bottom: -8vh;
}

.glow {
  position: absolute;
  width: 120vh;
  height: auto;
  bottom: -16vh;
}

.grand-lukto {
  position: absolute;
  width: 55vh;
  bottom: 16vh;
}

.shadow {
  position: absolute;
  width: 80vh;
  height: auto;
  bottom: -3vh;
}

.blu {
  position: absolute;
  resize: both;
  height: auto;
  bottom: 11vh;
  width: 43vh;
  margin-right: 65vh;
}

.fuse {
  position: absolute;
  resize: both;
  height: auto;
  bottom: 11vh;
  width: 39vh;
  margin-left: 72vh;
}

.sheal {
  position: absolute;
  width: 62vh;
  resize: both;
  height: auto;
  bottom: 20vh;
  margin-right: 10vh;
}

.leave-a {
  position: absolute;
  width: 40vh;
  min-width: 20vw;
  resize: both;
  height: auto;
  left: calc(10vw - 15vw);
  bottom: 0vh;
}

.leave-c {
  position: absolute;
  width: 20vh;
  min-width: 10vw;
  resize: both;
  height: auto;
  left: calc(10vw - 15vw);
  bottom: 8vh;
}

.leave-a-der {
  position: absolute;
  width: 40vh;
  min-width: 20vw;
  resize: both;
  height: auto;
  right: calc(10vw - 15vw);
  bottom: 0vh;
}

.leave-c-der {
  position: absolute;
  width: 20vh;
  min-width: 10vw;
  resize: both;
  height: auto;
  right: calc(10vw - 15vw);
  bottom: 7vh;
}

@media screen and (max-width: 1024px) {
  .castle-front {
    min-width: 170vw;
    width: 190vh;
    bottom: -8vh;
    left: -6vh;
  }

  .castle-back {
    width: 161vh;
    height: auto;
    left: -5vh;
    bottom: 16vw;
  }

  .middle-roof {
    width: 90vh;
    height: auto;
    bottom: 30vh;
  }

  .castle-roof {
    display: none;
  }

  .castle-tower {
    display: none;
  }

  .grand-lukto {
    width: 47vh;
    margin-bottom: 3vh;
  }

  .blu {
    width: 37vh;
    margin-right: 55vh;
    margin-bottom: 6vh;
  }

  .sheal {
    width: 46vh;
    margin-bottom: 6vh;
    margin-right: 8vh;
  }

  .fuse {
    width: 35vh;
    margin-left: 57vh;
    margin-bottom: 6vh;
  }

  .shadow {
    width: 71vh;
    height: auto;
    bottom: -2vh;
  }

  .leave-a {
    width: 30vh;
    left: calc(27vw - 15vw);
    bottom: 3vh;
  }

  .leave-c {
    width: 20vh;
    left: calc(24vw - 15vw);
    bottom: 7vh;
  }

  .leave-a-der {
    width: 30vh;
    right: calc(27vw - 15vw);
    bottom: 3vh;
  }

  .leave-c-der {
    width: 20vh;
    right: calc(25vw - 15vw);
    bottom: 6vh;
  }
}

@media screen and (max-width: 780px) {
  .castle-back {
    width: 131vh;
    height: auto;
    left: 1vh;
    bottom: 43vw;
  }

  .castle-front {
    min-width: 120vw;
    width: 190vh;
    bottom: -6vh;
    left: 8vh;
  }

  .grand-lukto {
    width: 35vh;
    margin-bottom: 10vh;
  }

  .blu {
    width: 25vh;
    margin-right: 53vw;
    margin-bottom: 13vh;
  }

  .sheal {
    width: 33vh;
    margin-bottom: 11vh;
    margin-right: 8vw;
  }

  .fuse {
    width: 23vh;
    margin-left: 52vw;
    margin-bottom: 13vh;
  }

  .leave-a {
    width: 20vh;
    left: calc(77vw - 15vw);
    bottom: 2vh;
  }

  .leave-c {
    width: 10vh;
    left: calc(77vw - 15vw);
    bottom: 6vh;
  }

  .leave-a-der {
    width: 20vh;
    right: calc(80vw - 15vw);
    bottom: 2vh;
  }

  .leave-c-der {
    width: 10vh;
    right: calc(78vw - 15vw);
    bottom: 6vh;
  }
}

@media (max-width: 900px) and (orientation: landscape) {
  .castle-front {
    position: absolute;
    min-width: 120vw;
    width: 273vh;
    bottom: -19vh;
    left: -21vh;
    overflow: hidden;
  }

  .castle-back {
    position: absolute;
    min-width: 110vw;
    width: 205vh;
    height: auto;
    left: -37vh;
    bottom: 6vw;
    overflow: hidden;
  }

  .middle-roof {
    position: absolute;
    width: 133vh;
    min-width: 70vw;
    height: auto;
    bottom: 31vh;
  }

  .castle-roof {
    display: block;
    position: absolute;
    bottom: 26vh;
    width: 40vh;
    min-width: 20vw;
    height: auto;
    right: -10vh;
  }

  .castle-tower {
    display: block;
    position: absolute;
    bottom: 25vh;
    right: -25vh;
    width: 52vh;
    min-width: 30vw;
    height: auto;
    resize: both;
  }

  .mist {
    position: absolute;
    width: 60vh;
    height: auto;
    bottom: -8vh;
  }

  .glow {
    position: absolute;
    width: 120vh;
    height: auto;
    bottom: -16vh;
  }

  .grand-lukto {
    position: absolute;
    width: 60vh;
    bottom: 12vh;
  }

  .shadow {
    position: absolute;
    width: 80vh;
    height: auto;
    bottom: -3vh;
  }

  .blu {
    position: absolute;
    resize: both;
    height: auto;
    bottom: 4vh;
    width: 48vh;
    margin-right: 72vh;
  }

  .fuse {
    position: absolute;
    resize: both;
    height: auto;
    bottom: 4vh;
    width: 45vh;
    margin-left: 80vh;
  }

  .sheal {
    position: absolute;
    width: 62vh;
    resize: both;
    height: auto;
    bottom: 14vh;
    margin-right: 10vh;
  }

  .leave-a {
    position: absolute;
    width: 40vh;
    min-width: 20vw;
    resize: both;
    height: auto;
    left: calc(10vw - 15vw);
    bottom: 0vh;
  }

  .leave-c {
    position: absolute;
    width: 20vh;
    min-width: 10vw;
    resize: both;
    height: auto;
    left: calc(10vw - 15vw);
    bottom: 8vh;
  }

  .leave-a-der {
    position: absolute;
    width: 40vh;
    min-width: 20vw;
    resize: both;
    height: auto;
    right: calc(10vw - 15vw);
    bottom: 0vh;
  }

  .leave-c-der {
    position: absolute;
    width: 20vh;
    min-width: 10vw;
    resize: both;
    height: auto;
    right: calc(10vw - 15vw);
    bottom: 7vh;
  }
}

@media (max-width: 730px) and (orientation: landscape) {
  .grand-lukto {
    position: absolute;
    width: 60vh;
    bottom: 6vh;
  }

  .blu {
    position: absolute;
    resize: both;
    height: auto;
    bottom: -1vh;
    width: 48vh;
    margin-right: 72vh;
  }

  .fuse {
    position: absolute;
    resize: both;
    height: auto;
    bottom: -1vh;
    width: 45vh;
    margin-left: 80vh;
  }

  .sheal {
    position: absolute;
    width: 56vh;
    resize: both;
    height: auto;
    bottom: 10vh;
    margin-right: 10vh;
  }
}

@media (max-width: 700px) and (orientation: landscape) {
  .grand-lukto {
    position: absolute;
    width: 55vh;
    bottom: 7vh;
  }

  .blu {
    position: absolute;
    resize: both;
    height: auto;
    bottom: -1vh;
    width: 48vh;
    margin-right: 70vh;
  }

  .fuse {
    position: absolute;
    resize: both;
    height: auto;
    bottom: -1vh;
    width: 45vh;
    margin-left: 76vh;
  }

  .sheal {
    position: absolute;
    width: 60vh;
    resize: both;
    height: auto;
    bottom: 10vh;
    margin-right: 10vh;
  }
}

@media screen and (max-width: 480px) {
  .castle-front {
    min-width: 120vw;
    width: 190vh;
    bottom: -5vh;
    left: 8vh;
  }

  .castle-back {
    width: 131vh;
    height: auto;
    left: -3vh;
    bottom: 54vw;
  }

  .middle-roof {
    width: 80vh;
    height: auto;
    bottom: 33vh;
  }

  .castle-roof {
    display: none;
  }

  .castle-tower {
    display: none;
  }

  .grand-lukto {
    width: 31vh;
    margin-bottom: 10vh;
  }

  .blu {
    width: 23vh;
    margin-right: 56vw;
    margin-bottom: 13vh;
  }

  .sheal {
    width: 32vh;
    margin-bottom: 10vh;
    margin-right: 10vw;
  }

  .fuse {
    width: 21vh;
    margin-left: 60vw;
    margin-bottom: 13vh;
  }

  .shadow {
    width: 47vh;
    height: auto;
    bottom: 2vh;
    margin-right: 3vh;
  }

  .leave-a {
    width: 20vh;
    left: calc(92vw - 15vw);
    bottom: 3vh;
  }

  .leave-c {
    width: 10vh;
    left: calc(94vw - 15vw);
    bottom: 7vh;
  }

  .leave-a-der {
    width: 20vh;
    right: calc(94vw - 15vw);
    bottom: 3vh;
  }

  .leave-c-der {
    width: 10vh;
    right: calc(94vw - 15vw);
    bottom: 7vh;
  }

  @media screen and (max-width: 420px) {
    .grand-lukto {
      width: 32vh;
      margin-bottom: 10vh;
    }

    .blu {
      width: 22vh;
      margin-right: 60vw;
      margin-bottom: 14vh;
    }

    .sheal {
      width: 32vh;
      margin-bottom: 11vh;
      margin-right: 10vw;
    }

    .fuse {
      width: 20vh;
      margin-left: 62vw;
      margin-bottom: 14vh;
    }

    .leave-a {
      width: 20vh;
      left: calc(110vw - 15vw);
      bottom: 2vh;
    }

    .leave-c {
      width: 10vh;
      left: calc(112vw - 15vw);
      bottom: 6vh;
    }

    .leave-a-der {
      width: 20vh;
      right: calc(115vw - 15vw);
      bottom: 2vh;
    }

    .leave-c-der {
      width: 10vh;
      right: calc(114vw - 15vw);
      bottom: 6vh;
    }
  }

  @media screen and (max-width: 390px) {
    .leave-a {
      width: 20vh;
      left: calc(106vw - 15vw);
      bottom: 2vh;
    }

    .leave-c {
      width: 10vh;
      left: calc(104vw - 15vw);
      bottom: 6vh;
    }

    .leave-a-der {
      width: 20vh;
      right: calc(106vw - 15vw);
      bottom: 2vh;
    }

    .leave-c-der {
      width: 10vh;
      right: calc(104vw - 15vw);
      bottom: 6vh;
    }
  }
  
  @media screen and (max-width: 320px) {
    .grand-lukto {
      width: 32vh;
      margin-bottom: 10vh;
    }

    .blu {
      width: 22vh;
      margin-right: 60vw;
      margin-bottom: 14vh;
    }

    .sheal {
      width: 32vh;
      margin-bottom: 11vh;
      margin-right: 10vw;
    }

    .fuse {
      width: 20vh;
      margin-left: 62vw;
      margin-bottom: 14vh;
    }

    .leave-a {
      width: 20vh;
      left: calc(90vw - 15vw);
      bottom: 2vh;
    }

    .leave-c {
      width: 10vh;
      left: calc(92vw - 15vw);
      bottom: 6vh;
    }

    .leave-a-der {
      width: 20vh;
      right: calc(95vw - 15vw);
      bottom: 2vh;
    }

    .leave-c-der {
      width: 10vh;
      right: calc(94vw - 15vw);
      bottom: 6vh;
    }
  }
}
</style>
